import React from 'react';

const Imprint = () => (
    <div className="container mt-5">
        <div className="row">
            <div className="col-12">
                <h2>Impressum</h2>
                <p className="mt-5">
                    <b>Informationspflicht laut § 5 TMG</b>
                </p>
                <p>
                    Backslash Seven GmbH<br/>
                    Großbeerenstr. 12<br/>
                    10963 Berlin<br/>
                    Deutschland
                </p>
                <p>
                    Telefon: 030 20006764<br/>
                    E-Mail: <a href="mailto:mail@backslashseven.de">mail@backslashseven.de</a><br/>
                    USt-ID: DE310801451<br/>
                    Register: Handelsregister<br/>
                    Registernummer: HRB 18675 B<br/>
                    Registergericht: Amtsgericht Charlottenburg<br/>
                    Geschäftsführer: Pascal Weber, Volkram Weber
                </p>
                <p className="mt-4">
                    <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</b>
                </p>
                <p>
                    Backslash Seven GmbH<br/>
                    Großbeerenstr. 12<br/>
                    10963 Berlin<br/>
                    Deutschland
                </p>
                <p className="mt-4">
                    <b>Datenschutz-Verantwortlicher</b>
                </p>
                <p>
                    Volkram Weber<br/>
                    Backslash Seven GmbH<br/>
                    Großbeerenstr. 12<br/>
                    10963 Berlin<br/>
                    Deutschland<br/>
                    E-Mail: <a href="mailto:mail@backslashseven.de">mail@backslashseven.de</a><br/>
                    Telefon: 030 20006764
                </p>
                <p className="mt-4">
                    <b>EU-Streitschlichtung</b>
                </p>
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                    <br/>
                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                        https://ec.europa.eu/consumers/odr
                    </a>
                    <br/>
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.<br/>
                    Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
                <p className="mt-3">
                    <b>Haftung für Inhalte dieser Website</b>
                </p>
                <p>
                    Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns, korrekte und aktuelle Informationen bereitzustellen.
                    Laut Telemediengesetz (TMG) § 7 (1) sind wir als Diensteanbieter für eigene Informationen, die wir zur Nutzung bereitstellen,
                    nach den allgemeinen Gesetzen verantwortlich. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite übernehmen,
                    speziell für jene, die seitens Dritter bereitgestellt wurden. Als Diensteanbieter im Sinne der §§ 8 bis 10 sind wir nicht verpflichtet,
                    die von Ihnen übermittelten oder gespeicherten Informationen zu überwachen oder nach Umständen zu forschen,
                    die auf eine rechtswidrige Tätigkeit hinweisen.
                    <br/>
                    Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
                    aufgrund von gerichtlichen oder behördlichen Anordnungen bleiben auch im Falle unserer Nichtverantwortlichkeit nach den §§ 8 bis 10 unberührt.
                    <br/>
                    Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitten wir Sie, uns umgehend zu kontaktieren,
                    damit wir die rechtswidrigen Inhalte entfernen können. Sie finden die Kontaktdaten im Impressum.
                </p>
                <p className="mt-3">
                    <b>Haftung für Links auf dieser Website</b>
                </p>
                <p>
                    Unsere Webseite enthält gelegentlich Links zu anderen Webseiten, für deren Inhalt wir nicht verantwortlich sind.
                    Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben,
                    uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.
                    <br/>
                    Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitten wir Sie, uns zu kontaktieren.
                    Sie finden die Kontaktdaten im Impressum.
                </p>
                <p className="mt-3 text-muted">
                    © {new Date().getFullYear()} Backslash Seven GmbH – Alle Rechte vorbehalten.
                </p>
            </div>
        </div>
    </div>
);

export default Imprint;